<template>
  <v-data-table
    :headers="fetchHeaders()"
    :items="scoreCosts"
    expand
    hide-actions
  >
    <template slot="headerCell" slot-scope="props">
      <v-tooltip bottom class="smallhead">
        <span slot="activator">{{ getHeaderTitle(props.header) }}</span>
        <span>{{ props.header.text }}</span>
      </v-tooltip>
      <div class="largehead">
        <span>{{ props.header.text }}</span>
      </div>
    </template>

    <template slot="items" slot-scope="props" style="height: 50px !important;">
      <td
        class="text-xs-left clickable"
        @click="edit(props.item)"
        v-if="!previsional"
      >
        <div>{{ props.item.expedition.number }}</div>
      </td>
      <td class="text-xs-left clickable" @click="edit(props.item)">
        <div v-if="isEdited(props.item)">
          <v-autocomplete
            :items="currencies"
            background-color="white"
            item-value="id"
            item-text="name"
            v-model="editedItem.currency_id"
            placeholder="select a currency"
            required
            class="small-font"
            v-on:keyup.enter="createOrUpdateItem"
          />
        </div>
        <div v-else>{{ props.item.currency.name }}</div>
      </td>
      <td class="clickable" @click="edit(props.item)">
        <div v-if="isEdited(props.item)">
          <v-text-field
            v-model="editedItem.unit_price"
            placeholder="unit price"
            onClick="this.select()"
            class="small-font"
            v-on:keyup.enter="createOrUpdateItem"
            required
          />
        </div>
        <div v-else>
          {{ inCurrency(props.item.currency.code, props.item.unit_price) }}
        </div>
      </td>
      <td class="clickable" @click="edit(props.item)">
        <div v-if="isEdited(props.item)">
          <v-text-field
            v-model="editedItem.quantity"
            placeholder="quantity"
            onClick="this.select()"
            class="small-font"
            v-on:keyup.enter="createOrUpdateItem"
            required
          />
        </div>
        <div v-else>{{ props.item.quantity }}</div>
      </td>

      <specificShowScoreCostColumns
        :scoreCost="props.item"
        :previsional="previsional"
      />

      <td class="text-xs-center" @click="edit(props.item)">
        <div v-if="props.item.bank_invoice">
          <del>{{ getComputedCostWithCurrentCurrency(props.item) }}</del>
          {{ getCostWithCurrentCurrency(props.item) }}
        </div>
        <div v-else>{{ getCostWithCurrentCurrency(props.item) }}</div>
      </td>

      <td class="clickable" @click="edit(props.item)">
        <v-layout row justify-center>
          <div v-if="isEdited(props.item)">
            <v-text-field
              v-model="editedItem.change_rate"
              placeholder="change rate"
              onClick="this.select()"
              class="small-font"
              v-on:keyup.enter="createOrUpdateItem"
              style="min-width: 45px;"
              required
            />
          </div>
          <div v-else>{{ props.item.change_rate }}</div>
        </v-layout>
      </td>

      <td class="text-xs-center" @click="edit(props.item)">
        {{ getCostWithScoreCurrency(props.item) }}
      </td>

      <td class="text-xs-left clickable">
        <div>
          {{ props.item.supplier_company && props.item.supplier_company.name }}
        </div>
      </td>

      <td class="min-width clickable" v-if="editable">
        <v-layout justify-end align-center row>
          <div v-if="isEdited(props.item)">
            <v-layout row>
              <v-btn fab small flat @click="createOrUpdateItem">
                <v-icon color="success">done</v-icon>
              </v-btn>
              <v-btn fab small flat @click="endEdit">
                <v-icon color="error">clear</v-icon>
              </v-btn>
            </v-layout>
          </div>
          <div v-else>
            <v-layout row>
              <v-btn
                fab
                small
                flat
                @click="showScoreCostSupplier(props.item)"
                color="theme_primary_lighten1"
              >
                <v-icon>store</v-icon>
              </v-btn>
              <v-btn
                fab
                small
                flat
                v-if="!previsional"
                @click="showScoreCostBankInvoiceDialog(props.item)"
                color="theme_primary_lighten1"
              >
                <v-icon>receipt</v-icon>
              </v-btn>
              <destroyModale
                resourceName="score_cost"
                :itemId="props.item.id"
                :small="true"
                warningText="You are going to remove this score cost permanently."
              />
            </v-layout>
          </div>
        </v-layout>
      </td>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import specificShowScoreCostColumns from "./specificShowScoreCostColumns";
import scoreCostDataTables from "../../mixins/scoreCostDataTables.js";
import scoreCost from "../../mixins/scoreCost";
import optimistic from "../../mixins/optimistic";

export default {
  name: "quantityUnitPriceScoreCost",
  mixins: [scoreCostDataTables, scoreCost, optimistic],
  components: { specificShowScoreCostColumns },
  props: {
    previsional: {
      type: Boolean,
      required: true,
    },
    editable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    ...mapGetters("contractStore", ["contract"]),
    ...mapGetters("commonStore", ["currencies"]),
  },
  methods: {
    specificHeaders() {
      return [
        {
          text: "Currency",
          align: "left",
          sortable: false,
          value: "currency.name",
        },
        {
          text: "Unit price",
          align: "left",
          sortable: false,
          value: "unit_price",
        },
        {
          text: "Quantity",
          align: "left",
          sortable: false,
          value: "quantity",
        },
      ];
    },
  },
};
</script>
